import angular from 'angular';

import addDisplayPostfix from '@angular/components/directives/addDisplayPostfix';

import avatar from './avatar';
import equals from './equals';
import focusOn from './focusOn';
import loadOnScroll from './loadOnScroll';
import ngThumb from './ngThumb';
import onEnter from './onEnter';
import onBackspace from './onBackspace';
import personaPicker from './personaPicker';
import progressButton from './progressButton';
import searchLookup from './searchLookup';
import selectedRow from './selectedRow';
import soundcloud from './soundcloud';
import spotify from './spotify';
import humanWhen from './humanWhen';
import validEmail from './validEmail';
import emoji from './emoji';
import imgToSvg from './imgToSvg';
import imageLoaded from './imageLoaded';
import onScreen from './onScreen';
import clampHtml from './clampHtml';
import switcher from './switcher';
import compileOnBound from './compileOnBound';
import scrollToSelected from './scrollToSelected';
import validHour from './validHour';
import validNumber from './validNumber';
import validPhoneNumber from './validPhoneNumber';
import timeSetter from './timeSetter';
import adjustToHorizontalScroll from './adjustToHorizontalScroll';
import phoneNumber from './phoneNumber';
import draggableShift from './draggableShift';
import draggableShiftIsDragging from './draggableShiftIsDragging';
import draggableShiftDropTarget from './draggableShiftDropTarget';
import matchStrong from './matchStrong';
import googleMap from './googleMap';
import formAgnostic from './formAgnostic';
import isScrolledDown from './isScrolledDown';
import checkbox from './checkbox';
import radiobutton from './radiobutton';
import addClassOnInit from './addClassOnInit';
import datepickerAddon from './datepickerAddon';
import datepickerWithAddon from './datepickerWithAddon';
import datepickerCustomRangePicker from './datepickerCustomRangePicker';
import dayInRange from './dayInRange';
import dayInPayrollPeriod from './dayInPayrollPeriod';
import datepickerDefaultDayHighlight from './datepickerDefaultDayHighlight';
import dayDefaultHighlight from './dayDefaultHighlight';
import inputWithLabel from './inputWithLabel';
import transitionHeight from './transitionHeight';
import getElement from './getElement';
import stickyThead from './stickyThead';
import stickyScroll from './stickyScroll';
import validateMinDate from './validateMinDate';
import alwaysPristine from './alwaysPristine';
import premiumGuard from './premiumGuard';
import zeroEmpty from './zeroEmpty';
import lingeringTooltip from './lingeringTooltip';
import hideValue from './hideValue';
import uibDatepickerPopupWrap from './uibDatepickerPopupWrap';
import formValid from './formValid';
import inputValid from './inputValid';
import isOverflown from './isOverflown';
import isScrolled from './isScrolled';
import blockInitialTransition from './blockInitialTransition';
import snowflakesify from './snowflakesify';
import focusImport from './focus';
import linkOrText from './linkOrText';
import getUibDropdownCtrl from './getUibDropdownCtrl';
import onlyDigits from './onlyDigits';
import validPin from './validPin';
import negateNgModel from './negateNgModel';
import numberInputFormatter from './numberInputFormatter';
import adaptParentHeight from './adaptParentHeight';
import scaleImage from './scaleImage';
import ifContent from './ifContent';
import dynamicInputParse from './dynamicInputParse';
import dynamicInputFormat from './dynamicInputFormat';
import draggableColumns from './draggableColumns';
import uibDropdownToggleInput from './dropdownToggle';
import positionColor from './positionColor';
import copyToClipboard from './copyToClipboard';
import tooltipKeepOnMouseover from './tooltipKeepOnMouseover';

const directivesModule = angular.module('components.directives', []);

directivesModule.directive('avatar', avatar);
directivesModule.directive('equals', equals);
directivesModule.directive('focusOn', focusOn);
directivesModule.directive('loadOnScroll', loadOnScroll);
directivesModule.directive('ngThumb', ngThumb);
directivesModule.directive('onEnter', onEnter);
directivesModule.directive('onBackspace', onBackspace);
directivesModule.directive('personaPicker', personaPicker);
directivesModule.directive('progressButton', progressButton);
directivesModule.directive('searchLookup', searchLookup);
directivesModule.directive('selectedRow', selectedRow);
directivesModule.directive('soundcloud', soundcloud);
directivesModule.directive('spotify', spotify);
directivesModule.directive('humanWhen', humanWhen);
directivesModule.directive('validEmail', validEmail);
directivesModule.directive('emoji', emoji);
directivesModule.directive('img', imgToSvg);
directivesModule.directive('imageLoaded', imageLoaded);
directivesModule.directive('onScreen', onScreen);
directivesModule.directive('clampHtml', clampHtml);
directivesModule.directive('switcher', switcher);
directivesModule.directive('compileOnBound', compileOnBound);
directivesModule.directive('scrollToSelected', scrollToSelected);
directivesModule.directive('validHour', validHour);
directivesModule.directive('validNumber', validNumber);
directivesModule.directive('validPhoneNumber', validPhoneNumber);
directivesModule.directive('timeSetter', timeSetter);
directivesModule.directive('adjustToHorizontalScroll', adjustToHorizontalScroll);
directivesModule.directive('phoneNumber', phoneNumber);
directivesModule.directive('draggableShift', draggableShift);
directivesModule.directive('draggableShiftIsDragging', draggableShiftIsDragging);
directivesModule.directive('draggableShiftDropTarget', draggableShiftDropTarget);
directivesModule.directive('matchStrong', matchStrong);
directivesModule.directive('googleMap', googleMap);
directivesModule.directive('formAgnostic', formAgnostic);
directivesModule.directive('isScrolledDown', isScrolledDown);
directivesModule.directive('checkbox', checkbox);
directivesModule.directive('radiobutton', radiobutton);
directivesModule.directive('addClassOnInit', addClassOnInit);
directivesModule.directive('datepickerAddon', datepickerAddon);
directivesModule.directive('datepickerWithAddon', datepickerWithAddon);
directivesModule.directive('datepickerCustomRangePicker', datepickerCustomRangePicker);
directivesModule.directive('dayInRange', dayInRange);
directivesModule.directive('dayInPayrollPeriod', dayInPayrollPeriod);
directivesModule.directive('datepickerDefaultDayHighlight', datepickerDefaultDayHighlight);
directivesModule.directive('dayDefaultHighlight', dayDefaultHighlight);
directivesModule.directive('inputWithLabel', inputWithLabel);
directivesModule.directive('transitionHeight', transitionHeight);
directivesModule.directive('getElement', getElement);
directivesModule.directive('stickyThead', stickyThead);
directivesModule.directive('stickyScroll', stickyScroll);
directivesModule.directive('validateMinDate', validateMinDate);
directivesModule.directive('alwaysPristine', alwaysPristine);
directivesModule.directive('premiumGuard', premiumGuard);
directivesModule.directive('zeroEmpty', zeroEmpty);
directivesModule.directive('lingeringTooltip', lingeringTooltip);
directivesModule.directive('hideValue', hideValue);
directivesModule.directive('uibDatepickerPopupWrap', uibDatepickerPopupWrap);
directivesModule.directive('formValid', formValid);
directivesModule.directive('inputValid', inputValid);
directivesModule.directive('isOverflown', isOverflown);
directivesModule.directive('isScrolled', isScrolled);
directivesModule.directive('blockInitialTransition', blockInitialTransition);
directivesModule.directive('linkOrText', linkOrText);
directivesModule.directive('getUibDropdownCtrl', getUibDropdownCtrl);
directivesModule.directive('onlyDigits', onlyDigits);
directivesModule.directive('validPin', validPin);
directivesModule.directive('negateNgModel', negateNgModel);
directivesModule.directive('adaptParentHeight', adaptParentHeight);
directivesModule.directive('scaleImage', scaleImage);
directivesModule.directive('ifContent', ifContent);
directivesModule.directive('dynamicInputParse', dynamicInputParse);
directivesModule.directive('dynamicInputFormat', dynamicInputFormat);
directivesModule.directive('uibDropdownToggle', uibDropdownToggleInput);
directivesModule.directive('draggableColumns', draggableColumns);
directivesModule.directive('numberInputFormatter', numberInputFormatter);
directivesModule.directive('positionColor', positionColor);
directivesModule.directive('copyToClipboard', copyToClipboard);
directivesModule.directive('tooltipKeepOnMouseover', tooltipKeepOnMouseover);
directivesModule.directive('addDisplayPostfix', addDisplayPostfix);

if (window._IS_CHRISTMAS_THEME) {
  directivesModule.directive('button', snowflakesify);
  directivesModule.directive('snowflakesify', snowflakesify);
}

directivesModule.factory('focus', focusImport);

export default directivesModule.name;
